export default {
  primary: '#00F29B',
  gold: '#ffd700',
  white: '#FFFFFF',
  black: '#000000',
  green: 'green',
};
